import { UserModel } from '@bsuccess/models/user.model';

export interface State {
    pending?: boolean;
    error?: string;
    form: string;
    welcomeType: string;
    key?: string;
    param?: string;
    user?: UserModel;
    tenant?: string;
    profilePic?: string;
    sessionKey?: string;
    object?: string;
    objectId?: string;
    parentId?: string;
    plans: any[];
    selectedPlan: any;
    pendingSignUp: boolean;
    userPaymentMethods: any;
    pendingPayment: boolean;
    paymentDone: boolean;
    pendingPaymentAddon: boolean;
    paymentAddonDone: boolean;
    taxes: any[];
    userInfo: any;
    signUpError?: string;
}

export const initialState: State = {
    pending: false,
    error: null,
    form: '',
    welcomeType: 'session',
    key: null,
    param: null,
    user: null,
    profilePic: null,
    tenant: 'beta',
    sessionKey: null,
    object: null,
    objectId: null,
    parentId: null,
    plans: [],
    selectedPlan: null,
    pendingSignUp: false,
    userPaymentMethods: null,
    pendingPayment: false,
    paymentDone: false,
    pendingPaymentAddon: false,
    paymentAddonDone: false,
    taxes: [],
    userInfo: null,
    signUpError: ''
};
